import React, { useEffect, useState } from 'react';

import { KeyOutlined, UserOutlined } from '@ant-design/icons';
import { Geo } from '@tenderd/schema';
import { getServer, useMixpanel } from '@tenderd/track-web-utils';
import { Button, Form, Input, message } from 'antd';
import ReactGA from 'react-ga';
import { Link, useHistory } from 'react-router-dom';
import { LoginPageEvents } from '../constants/AnalyticsEvents';
import OtpModal from "./components/OtpModal";
import ResetPasswordModal from "./components/ResetPasswordModal";
import EnrollAuthicatorApp from './components/EnrollAuthicatorApp';
const { Password } = Input;



const LoginPage: React.FunctionComponent<{}> = ({ }) => {
    const mixpanel = useMixpanel();
    const history = useHistory();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState<string>();
    const [otp, setOtp] = useState('');
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [showResetPassModal, setShowResetPassModal] = useState(false);
    const [mfaResponse, setMFAResponse] = useState<any>(null);
    const [mfaEnrollOpen, setMFAEnrollOpen] = useState(false);
    const [mfaQrCode, setMfaQrCode] = useState<string>('');
    const [mfaSecret, setMfaSecret] = useState<string>('');

    const postLogin = (result) => {
        mixpanel.track(
            `${LoginPageEvents.LoggedIn}`, { extension: "track", email }
        );
        ReactGA.event({
            category: LoginPageEvents.LoggedIn,
            action: 'Track WebApp',
        });
        setLoading(false);
        localStorage.setItem('loginResponse', JSON.stringify(result));
        if (search) {
            history.push("/auth/accounts" + search);
        }
        else {
            history.push("/auth/accounts");
        }
        return;
    }
    const handleOk = () => {
        setConfirmLoading(true);
        const mfa_token = mfaResponse.mfa_token;
        getServer(Geo.UAE).auth0VerifyAuthenticatorMFAUser({
            email,
            mfa_token,
            otp
        })
            .then((result) => {
                if (result === null) {
                    message.error('The OTP has expired, please try again.')
                    setOpen(false);
                    setEmail('')
                    setPassword('')
                    setOtp('')
                    setConfirmLoading(false);
                    return;
                } else if (result.success === false) {
                    message.error(result.message)
                    setConfirmLoading(false);
                    return;
                } else if (result.success) {
                    postLogin(result)
                    setConfirmLoading(false);
                }
            })
            .catch((error) => {
                setLoading(false);
                setConfirmLoading(false);
                console.error(error.message);
                message.error("Login failed, The OTP has expired, please try again.");
                setOtp('')
            });

    };

    const handleCancel = () => {
        setOpen(false);
        setMFAEnrollOpen(false);
        setLoading(false);
        setOtp('');
    };

    const checkValidity = () => {
        if (!email || email.trim().length === 0) {
            message.error('Email not filled in');
            return false;
        }
        if (!password || password.trim().length === 0) {
            message.error('Password not filled in');
            return false;
        }
        return true;
    };

    const removeLocalStorage = (val: string[]) => {
        val.forEach((item) => {
            localStorage.removeItem(item);
        });
    };

    const login = async () => {
        if (!checkValidity()) {
            return;
        }
        ReactGA.event({
            category: LoginPageEvents.ClickedLogInButton,
            action: 'Track WebApp',
        });
        setLoading(true);

        getServer(Geo.UAE)
            .auth0Login({
                email: email.trim(),
                password: password,
            })
            .then((result) => {
                if (result && result.message === "password_reset_required") {
                    getServer(Geo.UAE).auth0MigrateUser({
                        email: email.trim(),
                        password: password,
                    }).then((res) => {
                        if (res.success) {
                            login();
                        } else {
                            setLoading(false);
                            message.error('Something went wrong. Please try again later.');
                        }
                    }).catch(err => {
                        setLoading(false);
                        console.error(err.message);
                        message.error("Login failed: " + (err.message + "").toLowerCase().replace(/_/g, " "));
                    })
                } else if (result && result.message === "password_expired") {
                    setShowResetPassModal(true);
                    setLoading(false);
                    return;

                } else if (result && result.message === "otp_authenticator_enrolled") {
                    setMFAResponse(result)
                    setMfaQrCode(result.barcode_uri)
                    setMfaSecret(result.secret)
                    setMFAEnrollOpen(true)
                    return;
                } else if (result && result.mfa_token && result.message === 'otp_mfa_required') {
                    setMFAResponse(result)
                    setOpen(true)
                    setLoading(false)
                    return;
                } else if (result.success && result.token) {
                    postLogin(result)
                } else {
                    message.error(result.message);
                    setLoading(false)
                }

            })
            .catch((error) => {
                setLoading(false);
                console.error(error.message);
                message.error("Login failed: " + (error.message + "").toLowerCase().replace(/_/g, " "));
            });
    };

    const forgotPassword = () => {
        if (!email) {
            message.error('Please enter the email address');
            return;
        }
        setLoading(true);

        getServer(Geo.UAE)
            .auth0ForgetPassword({
                email,
            })
            .then((result) => {
                if (result.message) {
                    setLoading(false);
                    message.success(
                        'Check your email inbox for further instructions to reset your password.'
                    );
                }
            })
            .catch((error) => {
                setLoading(false);
                message.error(error.message);
            });
    };

    useEffect(() => {
        localStorage.removeItem('geoOverride');
        window.scrollTo(0, 0);

        setSearch(window.location.search);
    }, []);

    return (
        <div className="form-holder">
            <div className="holder">
                <h2>Login</h2>

                <p
                    className="semibold"
                    style={{ marginBottom: 40, color: '#666' }}
                >
                    Login with your Tenderd Track credentials
                </p>
                <Form
                    layout="vertical"
                >
                    <Form.Item
                        label={
                            <p
                                className="semibold"
                                style={{ color: '#666' }}
                            >
                                Email address
                            </p>
                        }
                    >
                        <Input
                            className="item"
                            placeholder="Email address.."
                            size="large"
                            prefix={
                                <UserOutlined
                                    style={{ color: 'rgba(0,0,0,.25)' }}
                                />
                            }
                            name="email"
                            value={email}
                            onChange={(e) =>
                                setEmail(e.target.value.trim())
                            }
                        />
                    </Form.Item>
                    <Form.Item
                        label={
                            <div
                                className="semibold"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    width: 400,
                                    color: '#666',
                                }}
                            >
                                <div style={{ flexGrow: 1 }}>
                                    Password
                                </div>

                            </div>
                        }
                    >
                        <Password
                            className="item"
                            placeholder="Password.."
                            size="large"
                            prefix={
                                <KeyOutlined
                                    style={{ color: 'rgba(0,0,0,.25)' }}
                                />
                            }
                            name="cc-num"
                            value={password}
                            onChange={(e) =>
                                setPassword(e.target.value)
                            }
                        />
                        <div style={{ display: "flex", justifyContent: "end" }}>
                            <Button
                                style={{ paddingRight: 0 }}
                                onClick={() => forgotPassword()}
                                type="link"
                            >
                                Forgot password?
                            </Button>
                        </div>
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            block
                            size="large"
                            loading={loading}
                            className="next-butt"
                            htmlType="submit"
                            onClick={() => login()}
                        >
                            Login
                        </Button>
                    </Form.Item>
                </Form>
                <div className="inner">
                    <div>
                        <div className="para semibold">
                            <p>Don't have an account yet?</p>
                            <OtpModal
                                otp={otp}
                                setOtp={setOtp}
                                open={open}
                                confirmLoading={confirmLoading}
                                handleOk={handleOk}
                                handleCancel={handleCancel}
                            />
                            <ResetPasswordModal
                                showResetPassModal={showResetPassModal}
                                setLoginPagePassword={setPassword}
                                setLoginPageEmail={setEmail}
                                email={email}
                                setShowResetPassModal={setShowResetPassModal}
                            />
                            <EnrollAuthicatorApp
                                qrCode={mfaQrCode}
                                secret={mfaSecret}
                                otp={otp}
                                setOtp={setOtp}
                                open={mfaEnrollOpen}
                                confirmLoading={confirmLoading}
                                handleOk={handleOk}
                                handleCancel={handleCancel}
                            />
                            <Link to={search ? "/auth/signup" + search : "/auth/signup"}>Signup here</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
